import { Link } from "react-router-dom";
import { GIFT_URL, PACKAGES_URL, IMG, LOCATION } from "../../data/site";
import { Reveal } from "../Reveal";
import { ConsultationForm } from "../ConsultationForm";

const COMPANY = [
  { img: IMG.weightConsult, kicker: "Physician-Supervised", title: "Medical Weight Loss", sub: "GLP-1 programs with weekly check-ins and optional sculpting.", to: "/treatments#weight-loss", id: "weight" },
  { img: IMG.brows, kicker: "Artistry & Correction", title: "Permanent Makeup", sub: "Brows, lip blush and corrective color, designed for you.", to: "/treatments#permanent-makeup", id: "pmu" },
];

export const GoodCompany = () => (
  <section className="bg-white py-24 md:py-32" data-testid="company-section">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8">
      <Reveal><p className="kicker mb-12 text-center">In Good Company</p></Reveal>
      <div className="grid gap-12 md:grid-cols-2">
        {COMPANY.map((c) => (
          <Reveal key={c.id}>
            <Link to={c.to} className="group block" data-testid={`company-card-${c.id}`}>
              <div className="aspect-[4/3] overflow-hidden"><img src={c.img} alt={c.title} className="img-zoom h-full w-full object-cover" loading="lazy" /></div>
              <p className="kicker mt-6">{c.kicker}</p>
              <h3 className="font-display mt-2 text-3xl font-light text-neutral-950">{c.title}</h3>
              <p className="mt-2 text-sm font-light text-neutral-600">{c.sub}</p>
              <span className="link-under mt-5">Explore More</span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

const TILES = [
  { img: IMG.desert, label: "Scottsdale", href: "/contact" },
  { img: IMG.giftArt, label: "Gift Cards", href: GIFT_URL },
  { img: IMG.membershipsArt, label: "Memberships & Packages", href: PACKAGES_URL },
  { img: IMG.bookOnline, label: "Book Online", href: "/book-online" },
];

export const WorldAccording = () => (
  <section className="bg-[hsl(var(--stone))] py-24 md:py-32" data-testid="world-section">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8">
      <Reveal className="mb-14 text-center">
        <h2 className="font-display text-4xl font-light tracking-[0.18em] text-neutral-950 md:text-5xl">LUX VERITAE SKIN SPA</h2>
        <p className="mx-auto mt-5 max-w-lg text-sm font-light text-neutral-600">Serving discerning clients in {LOCATION} and the surrounding communities.</p>
      </Reveal>
      <div className="no-scrollbar flex snap-x gap-6 overflow-x-auto pb-2">
        {TILES.map((t) => {
          const ext = t.href.startsWith("http");
          const Comp = ext ? "a" : Link;
          const props = ext ? { href: t.href, target: "_blank", rel: "noreferrer" } : { to: t.href };
          return (
            <Comp key={t.label} {...props} className="group relative block h-[420px] w-[70vw] shrink-0 snap-start overflow-hidden sm:w-[300px]" data-testid={`world-tile-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <img src={t.img} alt={t.label} className="img-zoom h-full w-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <span className="font-display absolute bottom-6 left-6 text-2xl text-white">{t.label}</span>
            </Comp>
          );
        })}
      </div>
    </div>
  </section>
);

export const ConsultSection = () => (
  <section id="consult" className="bg-[hsl(var(--mist))] py-24 md:py-32" data-testid="consult-section">
    <div className="mx-auto grid max-w-[1400px] gap-16 px-4 md:px-8 lg:grid-cols-[1fr_1.4fr]">
      <Reveal>
        <p className="kicker">Private Consultation</p>
        <h2 className="font-display mt-4 text-5xl font-light leading-[1.05] text-neutral-950 md:text-6xl">Your plan,<br /><em>personally composed.</em></h2>
        <p className="mt-8 max-w-md text-base font-light leading-relaxed text-neutral-600">
          Share a few details and our concierge will reach out by call, text or email to arrange your visit. Ready now? Reserve your time instantly online.
        </p>
        <Link to="/book-online" className="btn-line mt-10" data-testid="consult-book-btn">Book Online</Link>
      </Reveal>
      <Reveal><ConsultationForm /></Reveal>
    </div>
  </section>
);
